"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var states_1 = require("../../../../../common/constants/states");
var time_1 = require("../../../../../common/helpers/time");
var AdminInstructorsEditContactInfoController = /** @class */ (function () {
    function AdminInstructorsEditContactInfoController($state, UsersModel, FlashService, instructor) {
        this.editPassword = false;
        this.password = "";
        this.passwordConfirmation = "";
        this.states = states_1.States;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.$state = $state;
        this.instructor = instructor;
        // employment_start_date is stored as YYYY-MM-DD; the masked input expects MM/DD/YYYY.
        if (this.instructor.usermeta &&
            typeof this.instructor.usermeta === "object" &&
            !Array.isArray(this.instructor.usermeta) &&
            this.instructor.usermeta.employment_start_date) {
            this.instructor.usermeta.employment_start_date = (0, time_1.formatYmdForDisplay)(this.instructor.usermeta.employment_start_date);
        }
        this.submit = this.submit.bind(this);
    }
    AdminInstructorsEditContactInfoController.prototype.createUpdateRequest = function (instructor) {
        var instructorData = {
            id: instructor.id,
            email: instructor.email,
            username: instructor.username,
            nickname: instructor.nickname,
            firstname: instructor.firstname,
            lastname: instructor.lastname,
            notes: instructor.notes,
            usermeta: instructor.usermeta,
        };
        // Unticking "Edit Password" means "leave it alone", even if the hidden
        // boxes still hold something (typed earlier, or browser autofill).
        if (this.isChangingPassword()) {
            instructorData.password = this.password;
            instructorData.password_confirmation = this.passwordConfirmation;
        }
        return instructorData;
    };
    AdminInstructorsEditContactInfoController.prototype.isChangingPassword = function () {
        return this.editPassword && Boolean(this.password);
    };
    // The API has no `confirmed` rule on instructor updates, so this is the only
    // thing stopping a typo from locking the instructor out.
    AdminInstructorsEditContactInfoController.prototype.passwordsDoNotMatch = function () {
        return (this.isChangingPassword() && this.password !== this.passwordConfirmation);
    };
    AdminInstructorsEditContactInfoController.prototype.submit = function (isValid) {
        var _this = this;
        this.submitted = true;
        if (isValid && this.passwordsDoNotMatch()) {
            this.submitted = false;
            this.FlashService.setMessage({
                type: "error",
                message: AdminInstructorsEditContactInfoController.PASSWORD_MISMATCH_MESSAGE,
            });
            return;
        }
        if (isValid) {
            var payload = structuredClone(this.instructor);
            if (payload.usermeta &&
                typeof payload.usermeta === "object" &&
                !Array.isArray(payload.usermeta)) {
                if (payload.usermeta.license) {
                    var expDate = (0, time_1.parseMMDDYYYYDate)(payload.usermeta.license.expiration_date);
                    payload.usermeta.license.expiration_date = (0, time_1.formatDateTime)(expDate, "YYYY-MM-DD");
                }
                else {
                    delete payload.usermeta.license;
                }
                if (payload.usermeta.phone) {
                    payload.usermeta.phone = payload.usermeta.phone.toString();
                }
                if (payload.usermeta.employment_start_date) {
                    payload.usermeta.employment_start_date = (0, time_1.formatDisplayForYmd)(payload.usermeta.employment_start_date);
                }
            }
            delete payload.zones;
            delete payload.locations;
            delete payload.zoneparts;
            delete payload.sectors;
            this.UsersModel.updateInstructor(this.createUpdateRequest(payload))
                .then(function (response) {
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                _this.$state.go("drivecoach.admin.instructors.view", {
                    instructorId: response.instructor.id,
                });
                _this.submitted = false;
            })
                .catch(function (Error) {
                _this.submitted = false;
            });
        }
        else {
            this.submitted = false;
            this.FlashService.setMessage({
                type: "error",
                message: "Please fill the form.",
            });
        }
    };
    AdminInstructorsEditContactInfoController.PASSWORD_MISMATCH_MESSAGE = "Passwords do not match.";
    return AdminInstructorsEditContactInfoController;
}());
AdminInstructorsEditContactInfoController.$inject = [
    "$state",
    "UsersModel",
    "FlashService",
    "instructor",
];
exports.default = AdminInstructorsEditContactInfoController;
